import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const FCheckIcon = (props: IconProps) => (
  <StyledIcon
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path d="M9 21L1 13L4 10L9 15L21 3L24 6L9 21Z" fill="currentColor" />
  </StyledIcon>
)
